/* ============================================================================
   section-bd-artsy.js — open the Artsy door when navigated to via #bd-artsy
   (e.g. the "Push the door" collection card). Native <details> handles the
   rest; without JS the door simply stays closed until clicked.
   ============================================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function openIfHash() {
    if (location.hash !== '#bd-artsy') return;
    var d = document.getElementById('bd-artsy');
    if (d && !d.open) d.open = true;
  }

  openIfHash();
  window.addEventListener('hashchange', openIfHash);
})();
